import type { FaireProductEntity } from "../../entity_types/product";

export const p_3efk64u: FaireProductEntity = {
  token: "p_3efk64u",
  type: "product",
  name: "Doenjang Fermented Soybean Paste",
  brandName: "Potluck",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/75acd4ea788037ed83556862a2ba7e6d54c50c250950790b35ccc44f1f8271fc.webp",
  priceDollars: 14,
  description:
    "Deeply savory fermented soybean paste for stews, marinades, and dipping.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["korean", "fermented", "condiment", "artisanal"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/6edcc1e721d6c6e418cb5378f3f92caca5f10171ea43c6c3da92e2bc6f9da5b1.webp",
  weight: 1.2,
  dimensions: {
    width: 3,
    height: 5,
    depth: 3,
  },
  inStock: true,
};
